import React, { useEffect, useState } from 'react'
import Positions from '../../components/footer/positions/PositionsWrapper'
import BetInfoWrapper from './BetInfo'
import Cards from './cards/Cards'
import { texts } from './helper/textCombination'
import Text from './Text'

const CustomReply = ({ betReplyResponse, precision }: any) => {
  const {
    cards,
    state,
    ante,
    raise,
    turn,
    river,
    totalWin,
    currency,
    playerWinPositions,
    dealerWinPositions,
    playerWinType,
    dealerWinType,
  } = betReplyResponse

  const empty = ['0', '0', '0', '0', '0', '0', '0', '0', '0']
  const raiseStake = raise.bet
  const turnStake = turn.bet
  const riverStake = river.bet
  const anteStake = ante.bet
  const isFold = state === 6 && cards[cards.length - 1] === 'X0'
  const bets = [
    { title: 'ANTE', content: ante },
    {
      title: 'RAISE',
      content: raise,
    },
    {
      title: 'TURN',
      content: turn,
    },
    {
      title: 'RIVER',
      content: river,
    },
  ]
  const [winCombination, setWinCombination] = useState<string[]>(empty)

  useEffect(() => {
    if (state === 5 || isFold || (state === 11 && totalWin > '0')) {
      setWinCombination(playerWinPositions)
    } else if ((!isFold && state === 6) || (state === 11 && totalWin === '0')) {
      setWinCombination(dealerWinPositions)
    } else {
      setWinCombination(empty)
    }
  }, [playerWinPositions, dealerWinPositions, state])

  return (
    <>
      <Text text={texts.dealerTextBetReply(dealerWinType, state)} />
      <Cards cards={cards} winCombination={winCombination} />
      <Text
        text={texts.playerTextBetReply(
          playerWinType,
          currency,
          totalWin,
          state,
        )}
        margin={'30px 0 0 0'}
      />
      <Positions
        positionHolderVariables={{
          anteStake,
          raiseStake,
          turnStake,
          riverStake,
          padding: '48px',
        }}
      />
      {bets.map((item: any, i: number) => (
        <BetInfoWrapper
          key={i}
          data={item.content}
          title={item.title}
          currency={currency}
          precision={precision}
        />
      ))}
    </>
  )
}

export default CustomReply
